import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Confirm from '../../../../base/Confirm';
import ListView from '../../../../base/ListView';
import { toImmutable } from '../../../../libs/immutable-transformer';
import { ajaxErrorHandler, defaultSuccess, formatUTCDate } from '../../../../libs/utils';
import { selectEvent } from '../../../../redux/preferences/selectors';
import {
  createCateringClaim,
  deleteCateringClaim,
  getAllCateringClaims,
} from '../../../../services/api/cateringClaims';
import { getCateringOptions } from '../../../../services/api/cateringOptions';
import { getCompanies } from '../../../../services/api/companies';
import { getCrewMembers } from '../../../../services/api/crewMembers';
import CateringClaimsForm from '../../../forms/CateringClaimsForm';
import AdminSubHeader from '../../../layouts/partials/AdminSubheader';

class _CateringClaimsOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      baseFilters: toImmutable({
        'page[number]': 1,
        'page[size]': 50,
        'sort': '-created_at',
        'include':
          'crew-member,crew-member.user,crew-member,crew-member.registration,crew-member.registration.company,registration-catering-option,registration-catering-option.catering-option',
      }),
      claims: [],
      claimsMeta: {},
      cateringOptions: [],
    };

    this._getClaims = this._getClaims.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
  };

  UNSAFE_componentWillMount() {
    this._getClaims();

    getCateringOptions(this.props.event.id).then((response) => {
      this.setState({
        cateringOptions: response.data,
      });
    });
  }

  _getClaims(filters = this.state.baseFilters) {
    getAllCateringClaims(filters)
      .then((response) => {
        this.setState({
          claims: response.data,
          claimsMeta: response.meta,
        });
      })
      .catch(ajaxErrorHandler)
      .then(() => {
        this.setState({
          loading: false,
        });
      });
  }

  _handleSubmit(values) {
    let self = this;
    return new Promise((resolve, reject) => {
      createCateringClaim(values.registrationId, {
        crewMemberId: parseInt(values.crewMemberId, 10),
        cateringOptionId: parseInt(values.catering_option_id, 10),
        forced: true,
        reason: 'Manually Added',
        scannerName: 'CAS',
        claimedAt: values.day.format('YYYY-MM-DD') + ' 12:00:00',
      })
        .then((response) => {
          self._getClaims();
          defaultSuccess('Claim Added');
          resolve();
        })
        .catch(ajaxErrorHandler)
        .then(resolve);
    });
  }

  _handleDelete(claim) {
    Confirm('Are you sure you want to delete this Claim? This action can not be undone.', {
      title: 'Delete Claim',
      confirmStyle: 'btn-danger',
      confirmText: 'Delete',
    }).then(
      (result) => {
        deleteCateringClaim(claim.registrationCateringOption.registrationId, claim.id)
          .then((response) => {
            defaultSuccess('Claim deleted');
            this._getClaims();
          })
          .catch(ajaxErrorHandler);
      },
      (result) => {}
    );
  }

  render() {
    const { baseFilters, claims, claimsMeta, cateringOptions } = this.state;
    const { event } = this.props;

    const listViewConf = {
      dataSet: claims,
      dataMeta: claimsMeta,
      columns: [
        {
          key: 'registrationCateringOption.cateringOption.name',
          value: 'Catering',
        },
        {
          key: 'crewMember.registration.company.name',
          value: 'Company',
        },
        {
          key: 'name',
          value: 'Crewmember',
          render: (item) => item.crewMember.user.firstName + ' ' + item.crewMember.user.lastName,
        },
        {
          key: 'forced',
          value: 'Forced',
        },
        {
          key: 'createdAt',
          value: 'Scanned',
          render: (item) => formatUTCDate(item.createdAt, 'DD/MM/YYYY HH:mm:ss'),
        },
      ],
      baseFilters,
      filters: [
        {
          label: 'Company',
          icon: 'la-map-marker',
          type: 'typeahead',
          options: (value) =>
            getCompanies({
              'filter[name]': value,
            }),
          key: 'company_id',
          labelKey: 'name',
        },
        {
          label: 'Crewmember',
          icon: 'la-user',
          type: 'typeahead',
          options: (value) =>
            getCrewMembers({
              'filter[name_like]': value,
              'include': 'user',
            }),
          key: 'crew_member_id',
          labelKey: (item) => item.user.firstName + ' ' + item.user.lastName,
        },
        {
          label: 'Catering',
          icon: 'la-calendar',
          key: 'catering_option_id',
          type: 'select',
          dataset: cateringOptions.map((cateringOption) => {
            return {
              key: cateringOption.id,
              value: cateringOption.name,
            };
          }),
        },
      ],
      actions: {
        deleteLink: true,
        editLink: false,
        detailsLink: false,

        fullDelete: true,

        deleteFunction: this._handleDelete,
      },
      url: '/admin/catering-claims',
    };

    return [
      <AdminSubHeader title="Catering Claims" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-8">
            <ListView config={listViewConf} handleDelete={this._handleDelete} handleFilterUpdate={this._getClaims} />
          </div>
          <div className="col-xl-4">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-map-location" />
                    </span>
                    <h3 className="m-portlet__head-text">Add Claim</h3>
                  </div>
                </div>
              </div>
              <CateringClaimsForm onSubmit={this._handleSubmit} event={event} cateringOptions={cateringOptions} />
            </div>
          </div>
        </div>
      </div>,
    ];
  }
}
const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = function (state) {
  return {
    event: selectEvent(state),
  };
};

const CateringClaimsOverview = connect(mapStateToProps, mapDispatchToProps)(_CateringClaimsOverview);

export default CateringClaimsOverview;
